import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { ButtonGroup, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Box, Center, Group, Popover, Progress, RingProgress, Skeleton, Stack, Text, Tooltip as Ttip } from '@mantine/core';
import { IconButton, Tooltip } from '@material-ui/core';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import AddIcon from '@material-ui/icons/Add';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import InfoIcon from '@material-ui/icons/Info';
import DocumentsList from './DocumentsList';
import HeadingContainerNew from '../../../../neoverv/components/Module/General/HeadingContainerNew';
import { SUBSCRIPTION_CATEGORY, getSubscriptionTier, isStarterTier, isPremiumTier, isProfessionalTier } from '../../../../helpers/subscriptionFeatureAccess';
import breadcrumbsContent from '../../../../assets/breadcrumbs.json';
import HelpLogo from '../../../../assets/images/module/general/book.svg';
import TourIcon from '../../../../assets/images/module/general/TourIcon.svg';
import FileMoveIcon from '../../../../assets/images/module/general/FileMoveIcon.svg';
import GoldenLockIcon from '../../../../assets/images/module/general/GoldenLockIcon.svg';
import { ColorButton, FiltersContainer, HeadingContainer, SearchContainer } from '../../../../neoverv';
import Autoload from '../../../../neoverv/Autoload';
import { connect } from 'react-redux';
import { formatNumber } from '../../../../helpers/stringsManipulations';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

class List extends Component {
  state = {
    skeletonLoading: false,
    hoverMemory: false,
    memoryStatus: {usedSpaceInBytes: 0},
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    memoryStatusExceededPackageWise: null,
    usedSpaceInMB: null,
  };

  componentDidMount(){
    this.getDocumentsStatusByAccountId();
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(){
    if(this.props.refreshDocumentsData){
      this.getDocumentsStatusByAccountId();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {

    // TODO: this causes data refetch on the meters reading details screen...
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
    if (window.innerWidth <= TABLET_SIZE) {
      this.setState({ isTablet: true });
    } else {
      this.setState({ isTablet: false });
    }
    
  };

  convertFileSize=(sizeString)=>{
    if(sizeString){
      if(sizeString.includes('KB')){
        return parseFloat(sizeString) / 1000;
      }else if(sizeString.includes('GB')){
        return parseFloat(sizeString) * 1000;
      }else if(sizeString.includes('TB')){
        return parseFloat(sizeString) * 1000000;
      }else if(sizeString.includes('B') && (!sizeString.includes('M') || !sizeString.includes('G') || !sizeString.includes('T') || !sizeString.includes('K'))){
        return parseFloat(sizeString) / 1000000;
      }else {
        return parseFloat(sizeString);
      }
    }else{
      return 0;
    }
  }

  getDocumentsStatusByAccountId=()=>{
    const {accountData} = this.props;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.document_api_base_url + 'documents/status?accountId=' + accountData.accountId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetDocumentsStatusByAccountId',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleGetDocumentsStatusByAccountId(response){
    if(response.status && response.statuscode === 200){
      let usedSpaceInMB = (response.result.usedSpaceInBytes/1000000);
      let memoryStatusExceededPackageWise = isStarterTier(this.props.currentSubscription) ? usedSpaceInMB >= 100 : isPremiumTier(this.props.currentSubscription) ? usedSpaceInMB >= 1000 : false;
      this.setState({memoryStatus: response.result, usedSpaceInMB, memoryStatusExceededPackageWise});
      window.Intercom("update", {
        'document file size': (Math.round(response.result.usedSpaceInBytes / (1024*1024) * 100) / 100)
      });
    }
  }

  renderStorageCapacity=(displayUsed, displayLimit, usedSpace, limitSpace, availableSpace)=>{
    const {hoverMemory, isMobile} = this.state;
    return(
      <Center 
        style={{ cursor: 'pointer', height: '100%' }}
        onTouchStart={()=> this.setState({hoverMemory: !hoverMemory})} 
        onMouseEnter={()=> this.setState({hoverMemory: true})} 
        onMouseLeave={()=> this.setState({hoverMemory: false})}
      >
        {isMobile ?
        <Group style={{padding: '3px 9px 0px'}}>
          <InfoIcon
          style={{
            fontSize: '18px',
            color: '#5555FF'
          }}
          />
        </Group>
        :
        this.renderRingProgress(displayUsed, displayLimit, usedSpace, limitSpace, availableSpace)}
      </Center>
    )
  }

  ceilToNextThousand=(num) => {
    return Math.ceil(num / 1000) * 1000;
  }

  renderRingProgress=(displayUsed, displayLimit, usedSpace, limitSpace, availableSpace)=>{
    const {isMobile} = this.state;
    
    return(
      <RingProgress
      sections={[{ value: (usedSpace / availableSpace) * 100, color: usedSpace > availableSpace ? '#e8193c' : '#5555FF' }]}
      label={
        // <Center style={{ height: '100%' }}>
          <Text c={usedSpace > availableSpace ? '#e8193c' : '#5555FF'} fw={700} ta="center" size={isMobile ? "xs" : "sm"}>
            {displayUsed}
          </Text>
        // </Center>
      }
      size={isMobile ? 60 : 80}
      thickness={5}
      roundCaps
      />
    )
  }

  render() {
    const {skeletonLoading, hoverMemory, memoryStatus, isMobile, memoryStatusExceededPackageWise, usedSpaceInMB} = this.state;
    const {propertySelected, currentSubscription, accountData} = this.props;

    // --- START NEW LOGIC ---
    const usedMB = (memoryStatus?.usedSpaceInBytes || 0) / 1000000;
    
    // Determine if we should show GB or MB (Threshold: 1 GB = 1000 MB)
    const showInGB = usedMB >= 1000;

    // Determine the Base Limit based on subscription
    const subType = getSubscriptionTier(currentSubscription);
    let limitMB = 100; // Starter Default
    if (subType === SUBSCRIPTION_CATEGORY.PREMIUM) limitMB = 1000;
    if (subType === SUBSCRIPTION_CATEGORY.PROFESSIONAL) limitMB = 2000;

    // Calculate Dynamic Limit (if usage exceeds plan, limit grows)
    if (usedMB > limitMB) {
      limitMB = Math.round(usedMB) + 1;
    }

    // Format the Output Strings
    // If GB: 2 decimals (e.g., 2,40 GB). If MB: 0 decimals (e.g., 500 MB)
    const displayUsed = showInGB 
      ? `${(usedMB / 1000).toFixed(2).replace('.', ',')} GB` 
      : `${Math.round(usedMB)} MB`;

    const displayLimit = limitMB >= 1000 
      ? `${(limitMB / 1000).toFixed(0).replace('.', ',')} GB` 
      : `${Math.round(limitMB)} MB`;
    // --- END NEW LOGIC ---
    console.log('displayLimit: ', displayLimit);

    const usedSpace = (memoryStatus?.usedSpaceInBytes/1000000);
    const limitSpace = (isStarterTier(currentSubscription) ? 100 : isPremiumTier(currentSubscription) ? 1000 : isProfessionalTier(currentSubscription) && 2000);//parseFloat(displayLimit.replace(' GB', '').replace(' MB', '').replace(',', '.'));
    const availableSpace = (isProfessionalTier(currentSubscription) && usedSpace > limitSpace) ? this.ceilToNextThousand(usedSpace) : limitSpace;
    
    return (
      <div className="documents-main-container">
        <HeadingContainerNew
          heading={!isMobile && 'Dokumente'}
          headingClassName={'documents-heading tooltips'}
          
          className="documents-heading-container"
          rightContent={
            <Group>
              <Popover
  opened={hoverMemory}
  position="left" 
  withArrow
  transitionProps={{ duration: 800 }} // 1. Grouped transition props
>
  {/* 2. Target Wrapper */}
  <Popover.Target>
    {/* <Box h="100%"> */}
      {this.renderStorageCapacity(displayUsed, displayLimit, usedSpace, limitSpace, availableSpace)}
    {/* </Box> */}
  </Popover.Target>

  {/* 4. Dropdown Wrapper handles the boxShadow natively now */}
  <Popover.Dropdown style={{ boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 10px' }}>
    <Stack 
      style={{ width: isMobile ? '250px' : '190px' }} 
      gap={5} 
      onMouseEnter={() => this.setState({ hoverMemory: true })} 
      onMouseLeave={() => this.setState({ hoverMemory: false })}
    >
      <Group wrap="nowrap">
        <Stack gap={10} justify={'space-between'}>
          <Stack gap={5}>
            <span className="documents-header-right-section" style={{ fontWeight: '400' }}>
              Sie verwenden aktuell <span style={{ fontWeight: 'bold', color: usedSpace > availableSpace ? '#e8193c' : '#5555FF' }}>{displayUsed}</span>.
            </span>
            
            <>
              <span className="documents-header-right-section" style={{ fontWeight: '400' }}>
                Ihr Abonnement beinhaltet <span style={{ fontWeight: 'bold', color: '#5555FF' }}>{isStarterTier(currentSubscription) ? '100 MB' : isPremiumTier(currentSubscription) ? '1 GB' : '2 GB'}.</span>
                {isProfessionalTier(currentSubscription) ? 
                  <span> Speicherplatz (zusätzlicher Speicherplatz: 1 EUR / Monat je GB)</span> 
                  : usedSpace > availableSpace && <span> Sie haben den Speicherplatz Ihres Abonnements ausgeschöpft.</span>
                }
              </span>
              
              {isProfessionalTier(currentSubscription) && (memoryStatus?.usedSpaceInBytes / 1000000) > 2000 &&
                <span className="documents-header-right-section" style={{ fontWeight: '400' }}>
                  Sie nutzen derzeit <span style={{ fontWeight: 'bold', color: '#5555FF' }}>
                    {Math.round((memoryStatus?.usedSpaceInBytes / 1000000) - 2000)} MB
                  </span> zusätzlichen Speicherplatz.
                </span>
              }
            </>

            {(isPremiumTier(currentSubscription) || isStarterTier(currentSubscription)) && 
              <span className="documents-header-right-section" style={{ fontWeight: '400' }}>
                Schalten Sie <span style={{ fontWeight: 'bold', color: '#5555FF' }}>{isStarterTier(currentSubscription) ? '1 GB' : '2 GB'}</span> Speicherplatz frei mit <span style={{ fontWeight: 'bold' }}>hellohousing {isStarterTier(currentSubscription) ? 'Premium' : 'Professional'}.</span>
                <img src={GoldenLockIcon} width="11px" style={{ marginLeft: '6px', marginTop: '-4px' }} alt="lock" />
              </span> 
            }
          </Stack>
          
          {(isStarterTier(currentSubscription) || isPremiumTier(currentSubscription)) && 
            <ColorButton
              onClick={() => this.props.history.push('/profile/yourSubscription', { newSubscription: true })}
              className={"purple-btn"}
              text={'Jetzt freischalten'}
            />
          }
        </Stack>
        {/* Show RingProgress on mobile within the popover content */}
        {isMobile && this.renderRingProgress(displayUsed, displayLimit, usedSpace, limitSpace, availableSpace)} 
      </Group>
    </Stack>
    
    {/* ... commented out Progress bar remains ... */}
  </Popover.Dropdown>
</Popover>
            </Group>
          }
          breadcrumbsClassName={'documents-breadcrumbs'}
          breadcrumbs={<div style={{display: 'flex'}}>
          {breadcrumbsContent.map((item)=> item.area.includes('documents') && 
          item.breadcrumbs.map((breadcrumb)=>
          breadcrumb.type === 'tour' ? breadcrumb.condition === 'rental_unit_created' && breadcrumb.view === 'desktop' &&
          <div style={{display: 'flex', width: 'auto', alignItems: 'center', cursor: 'pointer', marginRight: '22px'}} onClick={()=> window.Intercom('startTour', breadcrumb.id)}>
            <Skeleton visible={skeletonLoading}>
              <img src={TourIcon} style={{marginTop: '-3px'}} />
              <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px'}}>{breadcrumb.label}</span>
            </Skeleton>
          </div>
          :
          breadcrumb.view === 'desktop' &&
          <div style={{display: 'flex', width: 'auto', alignItems: 'center', cursor: 'pointer', marginRight: '22px'}} onClick={()=> window.Intercom('showArticle', breadcrumb.id)}>
            <Skeleton visible={skeletonLoading}>
              <img src={HelpLogo} style={{marginTop: '-3px'}} />
              <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px'}}>{breadcrumb.label}</span>
            </Skeleton>
          </div>
          ))}
          </div>}
        />
        <div>
          <Route path={this.props.match.url} exact //component={DocumentsList} 
          render={(props)=> <DocumentsList {...props} isMobile={isMobile} memoryStatusExceededPackageWise={memoryStatusExceededPackageWise} usedSpaceInMB={usedSpaceInMB} memoryStatus={memoryStatus}/>}/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    currentSubscription: state.generalReducer.currentSubscription,
    accountData: state.generalReducer.accountData,
    refreshDocumentsData: state.generalReducer.refreshDocumentsData,
  };
};

export default connect(mapStateToProps, null)(withRouter(List));
